import { Formik } from "formik";
import React, { useContext } from "react";
import { Card, CardHeader, Col, Container, Form, Input, Row } from "reactstrap";
import * as Yup from "yup";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import UiContent from "../../Components/Common/UiContent";
import SignContext from "../../contextAPI/Context/SignContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const AddCheckupType = () => {
  const { AddCheckupType } = useContext(SignContext);

  const handleSavedCheckupType = async (Values) => {
    try {

      const res = await AddCheckupType(Values);





      // Check if response indicates failure (from catch block in SignState)
      if (res && res.success === false) {
        toast.error(res.message || res.msg || "Failed to add checkup type");
        return;
      }
      
      // Check for successful response
      if (res && res.message) {
        // Check if it's a duplicate
        if (res.message.toLowerCase().includes("already") || res.message.toLowerCase().includes("alredy")) {
          toast.warning("Checkup type already exists!");
        } else {
          toast.success("Checkup Type added successfully!");
        }
      } else {

        toast.error("Failed to add checkup type. No response received.");
      }
    } catch (error) {

      toast.error("Failed to add checkup type. Please try again.");
    }
  };

  const validationSchema = Yup.object().shape({
    checkupType: Yup.string().required("checkup is required"),
  });

  return (
    <>
      <ToastContainer />
      <UiContent />
      <div className="page-content">
        <Container fluid>
          <BreadCrumb grandParent="Setup" parent="Forms" child="Form-1" />
          <Row>
            <Col lg={12}>
              <Formik
                initialValues={{
                  checkupType: "",
                }}
                validationSchema={validationSchema}
                onSubmit={async (values, { resetForm }) => {
                  handleSavedCheckupType(values);
                  resetForm();
                  // Additional actions after form submission
                  // togglemodal();
                }}
              >
                {({
                  handleChange,
                  handleSubmit,
                  errors,
                  touched,
                  values,
                  handleBlur,
                }) => (
                  <Form onSubmit={handleSubmit}>
                    {/* Your form fields and components */}
                    <Card>
                      <CardHeader>
                        <Row className="g-1 m-1">
                          <Col className="col-sm">
                            <div className="d-flex justify-content-sm-between">
                              <h2 className="card-title mb-0 justify-content-sm-start">
                                <strong>Title</strong>
                              </h2>
                            </div>
                          </Col>
                        </Row>
                      </CardHeader>
                      <div className="card-body">
                        <div className="live-preview">
                          <Row className="align-items-center g-3">
                            <Col sm={6}>
                              <label
                                className="form-label mt-3"
                                htmlFor="product-orders-input"
                              >
                                Add Checkup-type
                              </label>
                              <div className="">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="Add Checkup-type"
                                  name="checkupType"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.checkupType}
                                />
                              </div>
                              <p className="error text-danger">
                                {errors.checkupType &&
                                  touched.checkupType &&
                                  errors.checkupType}
                              </p>
                            </Col>
                          </Row>
                        </div>
                      </div>
                      <div className="text-end mb-3 me-3">
                        <button className="btn btn-success w-sm" type="submit">
                          Submit
                        </button>
                      </div>
                    </Card>
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default AddCheckupType;
